<template>
    <div id="imprimbook-home"></div>
</template>

<script>

export default {
    name: "ImprimBookHome",
};
</script>

<style lang="scss" scoped>
    #imprimbook-home {
        height: 100px;
    }
</style>